import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchWithAuth } from "../api/AuthApi.services";
import "./OrdersPage.css";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchOrders() {
      try {
        const accessToken = localStorage.getItem("accessToken");
        const headers = {
          "Content-Type": "application/json",
        };

        if (accessToken) {
          headers.Authorization = `Bearer ${accessToken}`;
        }

        const response = await fetchWithAuth(`${API_BASE_URL}/order/orders/`, {
          method: "GET",
          headers: headers,
        });

        if (response.ok) {
          const data = await response.json();
          setOrders(data);
        } else {
          throw new Error("Failed to fetch orders.");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    }

    fetchOrders();
  }, []);

  const handleViewDetails = (orderId) => {
    navigate(`/orders/${orderId}`);
  };

  if (loading) {
    return <p>Loading orders...</p>;
  }

  if (error) {
    return <p className="error">{error}</p>;
  }

  return (
    <div className="orders-page">
      <h2 className="orders-title">My Orders</h2>
      {orders.length > 0 ? (
        <table className="orders-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Order Date</th>
              <th>Status</th>
              {/* <th>Shipped Via</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
  {orders.map((order) => (
    <tr key={order.id}>
  <td>
  <div>
    <strong>Order ID:</strong> {order.order_id}
  </div>
  <div>
    <strong>Products:</strong>
    <ul style={{ paddingLeft: "1rem", margin: 0 }}>
      {order.details.map((item, index) => (
        <li key={index}>
          {item.product_name} (Qty: {item.quantity})
        </li>
      ))}
    </ul>
  </div>
</td>

      <td>
        {new Date(order.order_date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </td>
      <td>{order.order_status}</td>
      <td>
        <button
          className="view-details-btn"
          onClick={() => handleViewDetails(order.id)}
        >
          View Details
        </button>
      </td>
    </tr>
  ))}
</tbody>

        </table>
      ) : (
        <p className="no-orders">No orders found.</p>
      )}
    </div>
  );
};

export default OrdersPage;
